/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ServiceStatusFromJSON, ServiceStatusToJSON, } from './';
export function ServiceActionCreateUpdateDtoFromJSON(json) {
    return ServiceActionCreateUpdateDtoFromJSONTyped(json, false);
}
export function ServiceActionCreateUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeId': !exists(json, 'typeId') ? undefined : json['typeId'],
        'required': !exists(json, 'required') ? undefined : json['required'],
        'startDateTime': !exists(json, 'startDateTime') ? undefined : (new Date(json['startDateTime'])),
        'endDateTime': !exists(json, 'endDateTime') ? undefined : (new Date(json['endDateTime'])),
        'status': !exists(json, 'status') ? undefined : ServiceStatusFromJSON(json['status']),
    };
}
export function ServiceActionCreateUpdateDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'carId': value.carId,
        'name': value.name,
        'description': value.description,
        'typeId': value.typeId,
        'required': value.required,
        'startDateTime': value.startDateTime === undefined ? undefined : (value.startDateTime.toISOString()),
        'endDateTime': value.endDateTime === undefined ? undefined : (value.endDateTime.toISOString()),
        'status': ServiceStatusToJSON(value.status),
    };
}
